// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"3afe5db9","668":"332093ab"}[chunkId] + ".chunk.js";
};